import { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import isString from 'lodash/isString';

export interface IStackProps extends HTMLAttributes<HTMLDivElement> {
  'data-qa'?: string;
  spacing?: string | number;
  direction?: 'row' | 'column';
}

export const Stack = ({ spacing = '', direction = 'column', ...rest }: IStackProps) => {
  return (
    <Stack.Root
      {...rest}
      $direction={direction}
      $spacing={isString(spacing) ? spacing : `${spacing}px`}
    />
  );
};

interface IStackRootStyleProps {
  $direction: 'row' | 'column';
  $spacing?: string;
}

Stack.Root = styled.div<IStackRootStyleProps>`
  display: flex;
  flex-direction: ${({ $direction }) => $direction};
  ${({ $spacing, $direction }) => css`
    > :where(:not(:first-child)) {
      margin-${$direction === 'row' ? 'left' : 'top'}: ${$spacing};
    }`}
`;
